import React, { useState, useEffect } from 'react';
import { Manage } from '../shared/Manage';

// Dữ liệu mẫu
const mockData = [
  {
    id: 1,
    priority: true,
    date: '2024-03-15',
    content: 'Gợi ý 1: Bệnh viện có đội ngũ bác sĩ chuyên môn cao',
    source: 'Từ file',
    // status: 'active'
  },
  {
    id: 2,
    priority: false,
    date: '2024-03-14',
    content: 'Gợi ý 2: Dịch vụ khám bệnh online qua ứng dụng',
    source: 'Từ file',
    // status: 'pending'
  }
];

// Cấu hình cột
const columns = [
  { key: 'priority', label: 'Priority (max 5)', type: 'checkbox' },
  { key: 'date', label: 'Date Create', type: 'text' },
  { key: 'content', label: 'Suggest', type: 'text' },
  { key: 'source', label: 'Source', type: 'text' },
  // {
  //   key: 'status',
  //   label: 'Status',
  //   type: 'custom',
  //   render: (item) => (
  //     <span className={`px-2 py-1 rounded text-xs ${
  //       item.status === 'active'
  //         ? 'bg-green-100 text-green-800'
  //         : 'bg-yellow-100 text-yellow-800'
  //     }`}>
  //       {item.status}
  //     </span>
  //   )
  // }
];

const ManageSuggested = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  // Giả lập fetch data
  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      setData(mockData);
      setLoading(false);
    },200);
  }, []);

  // Xử lý các sự kiện
  const handleEdit = (item) => {
    console.log('Edit item:', item);
    // TODO: logic edit
  };

  const handleDelete = (item) => {
    setData(prev => prev.filter(i => i.id !== item.id));
  };

  const handlePriorityChange = (item) => {
    setData(prev =>
      prev.map(i =>
        i.id === item.id ? { ...i, priority: !i.priority } : i
      )
    );
  };

  return (
    <Manage
      type="suggested"
      tableProps={{
        data,
        loading,
        columns,
        onEdit: handleEdit,
        onDelete: handleDelete,
        onPriorityChange: handlePriorityChange,
        emptyMessage: "Không có gợi ý nào",
        deleteConfirmMessage: "Bạn có chắc chắn muốn xóa gợi ý này không?"
      }}
    />
  );
};

export { ManageSuggested };
